import React, { useState, useContext, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CourierTableHead from './CourierTableHead'
import { CommonContext } from '../../../../context';
import TableSkeleton from '../../../common/TableSkeleton';
import TablePagination from '@mui/material/TablePagination';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function CourierTable() {
  const { merchantCourier, mCourierLoading, onMerchantCourier, rowData } = useContext(CommonContext);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('created_at');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  useEffect(() => {
    if (rowData) {
      onMerchantCourier(rowData?.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = merchantCourier.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };


  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - merchantCourier.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(merchantCourier, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, merchantCourier],
  );
  return (
    <div className='table-component'>
      {mCourierLoading ?
        <>
          <TableContainer>
            <Table size="small">
              <CourierTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={merchantCourier.length}
              />
              <TableBody>
                {visibleRows.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row?.courier_id}
                      </TableCell>
                      <TableCell align="left">{row?.courier?.brand_name}</TableCell>
                    </TableRow>
                  );
                })}
                {!visibleRows.length && (
                  <TableRow
                    style={{
                      height: (53) * emptyRows,
                    }}
                    rowSpan={5}
                  >
                    <TableCell colSpan={10} >
                      <Typography align="center" style={{ marginTop: 20, marginBottom: 20 }}>
                        No Records Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {visibleRows.length > 0 &&
            <TablePagination
              rowsPerPageOptions={[30, 50, 100, 250]}
              component="div"
              count={merchantCourier.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          }
        </>
        :
        <TableSkeleton rows={10} columns={3} />
      }
    </div>

  );
}